import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App.tsx'
import './index.css'

Sentry.init({
  dsn: import.meta.env.SENTRY_DSN,
  integrations: [],
  enabled: Boolean(import.meta.env.SENTRY_DSN && process.env.NODE_ENV === 'production'),
  environment: import.meta.env.MODE
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
